import { useState, useCallback } from 'react';
import { generateText } from '@/components/v2/tools/text/textGenerationApi';

/** Generate WCAG-style alt text from a product image (vision input). */
export function useGenerateAltText() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const generate = useCallback(async (productId: string, assetId: string): Promise<string> => {
    setLoading(true);
    setError(null);
    try {
      const resp = await generateText({
        tool_code: '', prompt: '',
        product_id: productId, field_type: 'image_alt', image_key: assetId,
      });
      if (!resp.success) throw new Error(resp.error || 'generation_failed');
      return resp.content;
    } catch (e) {
      setError(e instanceof Error ? e.message : 'generation_failed');
      return '';
    } finally {
      setLoading(false);
    }
  }, []);

  return { generate, loading, error };
}
